export const MESSAGES = {
  SLIVER_VALUE_PROPOSITION_CAROUSEL: {
    SLIDE_1: {
      ILLUSTRATION_URL: '/images/svg/rarity.svg',
      TITLE: 'Invest in markets available to less than 0.08% of humanity.',
      DECRIPTION:
        'Discover only the most researched and proven investment opportunities in digital assets. Accessing these markets is incredibly hard, but Sliver makes it effortlessly straightforward.',
    },
    SLIDE_2: {
      ILLUSTRATION_URL: '/images/svg/peace.svg',
      TITLE: 'Invest with unparalleled ease, control, and confidence.',
      DECRIPTION:
        'Invest with only a tap or two. Sliver does the heavy lifting, so you don’t have to. If ideas and insights are what you seek, then all the information you’ll ever need are also just as many taps away.',
    },
    SLIDE_3: {
      ILLUSTRATION_URL: '/images/svg/privacy.svg',
      TITLE: 'Invest on your own terms without boundaries or restrictions.',
      DECRIPTION:
        'Never share your personal information or seek approvals and accreditations with Sliver. Sliver will never ask you who you are or what you do, so you can invest in complete privacy.',
    },
  },
  YIELD_BEARING_ASSETS: {
    LOADING_TITLE: 'Earn strategies are being fetched.',
    LOADING_DESCRIPTION:
      'We’re currently fetching Earn strategies. This will only take a moment.',
    ERROR_LOADING_TITLE: 'Temporary glitch showing Earn strategies.',
    ERROR_LOADING_DESCRIPTION:
      'We’re experiencing a temporary glitch showing Earn strategies. Try refreshing the page, or please check back again in a few minutes.',
    NO_FILTERED_YIELD_BEARING_ASSETS_FOUND_TITLE:
      'No matching Earn strategies found.',
    NO_FILTERED_YIELD_BEARING_ASSETS_FOUND_DESCRIPTION:
      'There are currently no Earn strategies that match your filters. Try adjusting your filters to view available strategies.',
    NO_YIELD_BEARING_ASSETS_FOUND_TITLE: 'No Earn strategies found.',
    NO_YIELD_BEARING_ASSETS_FOUND_DESCRIPTION:
      'There are currently no Earn strategies to show. Try refreshing the page, or please check back again in a few minutes.',
    NO_ASSETS_FOUND_TITLE: 'No assets found.',
    NO_ASSETS_FOUND_DESCRIPTION: `You don't have any assets in your wallet just yet. If you are new to Sliver, please get started by depositing assets into your wallet.`,
  },
  YIELD_BEARING_ASSET_DETAIL: {
    LOADING_TITLE: 'Assets are being fetched.',
    LOADING_DESCRIPTION: `We're currently fetching all relevant assets. This will only take a moment.`,
    ERROR_LOADING_TITLE: 'Temporary glitch showing [asset_ticker].',
    ERROR_LOADING_DESCRIPTION: `We’re experiencing a temporary glitch showing [asset_ticker]. Try refreshing the page, or please check back again in a few minutes.`,
    ASSET_NOT_FOUND_ERROR_TITLE: '[asset_ticker] not found.',
    ASSET_NOT_FOUND_ERROR_DESCRIPTION: `It doesn't seem like we have listed an asset with ticker [asset_ticker]. Please choose from an asset we've listed to view its details.`,
    ASSET_COMPOSITION_SUMMARY:
      '[yield_bearing_asset_name] is composed of [no_of_underlying_assets] assets.',
    COMPOSITION_EXPLANATION_TITLE: 'Asset Composition',
    COMPOSITION_EXPLANATION_DESCRIPTION: `The funds you invest in this asset will automagically be split and deposited into the specified underlying assets in the specified proportion. Composition of assets impacts your tolerance for risk and the extent of potential returns. Higher returns typically come with higher risks, so it's important to choose a composition that aligns with your overall investment objectives. With Sliver, in just a few seconds, you can personalize the compositiion exactly to your preference.`,
    RESEARCH: {
      LOADING_TITLE: 'Research is being compiled.',
      LOADING_DESCRIPTION: `We're currently compiling research for this asset. This will only take a moment.`,
    },
  },
  YIELD_BEARING_ASSET_ACTIONS: {
    CONFIRMATION_REQUEST_SCREEN: {
      DEPOSIT: {
        ASSET_FIELD_HELP_TITLE: 'Asset',
        ASSET_FIELD_HELP_DESCRIPTION:
          'This is the asset in your wallet that you will use to buy [yield_bearing_asset_name] ([yield_bearing_asset_ticker]) with.',
        WALLET_FIELD_HELP_TITLE: 'Wallet',
        WALLET_FIELD_HELP_DESCRIPTION:
          'This is the wallet that has the [token_name] ([token_symbol]) that you will use to buy [yield_bearing_asset_name] ([yield_bearing_asset_ticker]) with.',
        AMOUNT_FIELD_HELP_TITLE: 'Amount',
        AMOUNT_FIELD_HELP_DESCRIPTION:
          'This is the amount of [token_name] ([token_symbol]) that you will use to buy [yield_bearing_asset_name] ([yield_bearing_asset_ticker]) with.',
        NETWORK_FEE_FIELD_HELP_TITLE: 'Network fee',
        NETWORK_FEE_FIELD_HELP_DESCRIPTION:
          "This is the amount of [token_name] ([token_symbol]) that you will pay in fees to the blockchain network to facilitate this transaction. Depending on the time of the day and how busy the network is, this fee can fluctuate quite a bit. Sliver doesn't dictate or acquire any part of this fee.",
        CONVENIENCE_FEE_FIELD_HELP_TITLE: 'Service fee',
        CONVENIENCE_FEE_FIELD_HELP_DESCRIPTION:
          'This is the amount of [token_name] ([token_symbol]) that you will pay in fees to Sliver to facilitate this transaction. This amounts to [convenience_fee_percent]% of the overall transaction value.',
      },
      WITHDRAWAL: {
        ASSET_FIELD_HELP_TITLE: 'Asset',
        ASSET_FIELD_HELP_DESCRIPTION:
          'This is the asset that you will receive in your wallet in exchange for selling [yield_bearing_asset_name] ([yield_bearing_asset_ticker]).',
        WALLET_FIELD_HELP_TITLE: 'Wallet',
        WALLET_FIELD_HELP_DESCRIPTION:
          'This is the wallet where you will receive [token_name] ([token_symbol]) in exchange for selling [yield_bearing_asset_name] ([yield_bearing_asset_ticker]).',
        AMOUNT_FIELD_HELP_TITLE: 'Amount',
        AMOUNT_FIELD_HELP_DESCRIPTION:
          'This is the amount of [token_name] ([token_symbol]) that you will receive in exchange for selling [yield_bearing_asset_name] ([yield_bearing_asset_ticker]).',
        NETWORK_FEE_FIELD_HELP_TITLE: 'Network Fee',
        NETWORK_FEE_FIELD_HELP_DESCRIPTION:
          'This is the amount of [token_name] ([token_symbol]) that you will use to pay as fees to the blockchain network to process your transaction. Sliver does not control or receive any part of this fee.',
        CONVENIENCE_FEE_FIELD_HELP_TITLE: 'Service Fee',
        CONVENIENCE_FEE_FIELD_HELP_DESCRIPTION:
          'This is the amount of [token_name] ([token_symbol]) that you will use to pay as fees to Sliver for facilitating your transaction. This amounts to [convenience_fee_percent]% of the total transaction value.',
      },
    },
    CONFIRMATION_RECEIPT_SCREEN: {
      DEPOSIT: {
        ASSET_FIELD_HELP_TITLE: 'Asset',
        ASSET_FIELD_HELP_DESCRIPTION:
          'This is the asset in your wallet that you used to buy [yield_bearing_asset_name] ([yield_bearing_asset_ticker]) with.',
        WALLET_FIELD_HELP_TITLE: 'Wallet',
        WALLET_FIELD_HELP_DESCRIPTION:
          'This is the wallet that had the [token_name] ([token_symbol]) that you used to buy [yield_bearing_asset_name] ([yield_bearing_asset_ticker]) with.',
        AMOUNT_FIELD_HELP_TITLE: 'Amount',
        AMOUNT_FIELD_HELP_DESCRIPTION:
          'This is the amount of [token_name] ([token_symbol]) that you used to buy [yield_bearing_asset_name] ([yield_bearing_asset_ticker]) with.',
        NETWORK_FEE_FIELD_HELP_TITLE: 'Network fee',
        NETWORK_FEE_FIELD_HELP_DESCRIPTION:
          "This is the amount of [token_name] ([token_symbol]) that you paid in fees to the blockchain network to facilitate this transaction. Sliver doesn't dictate or acquire any part of this fee.",
        CONVENIENCE_FEE_FIELD_HELP_TITLE: 'Service fee',
        CONVENIENCE_FEE_FIELD_HELP_DESCRIPTION:
          'This is the amount of [token_name] ([token_symbol]) that you paid in fees to Sliver to facilitate this transaction. This amounts to [convenience_fee_percent]% of the overall transaction value.',
      },
      WITHDRAWAL: {
        ASSET_FIELD_HELP_TITLE: 'Asset',
        ASSET_FIELD_HELP_DESCRIPTION:
          'This is the asset that you will receive in your wallet in exchange for selling [yield_bearing_asset_name] ([yield_bearing_asset_ticker]).',
        WALLET_FIELD_HELP_TITLE: 'Wallet',
        WALLET_FIELD_HELP_DESCRIPTION:
          'This is the wallet where you will receive [token_name] ([token_symbol]) in exchange for selling [yield_bearing_asset_name] ([yield_bearing_asset_ticker]).',
        AMOUNT_FIELD_HELP_TITLE: 'Amount',
        AMOUNT_FIELD_HELP_DESCRIPTION:
          'This is the amount of [token_name] ([token_symbol]) that you will receive in exchange for selling [yield_bearing_asset_name] ([yield_bearing_asset_ticker]) once this transaction has been processed.',
        NETWORK_FEE_FIELD_HELP_TITLE: 'Network Fee',
        NETWORK_FEE_FIELD_HELP_DESCRIPTION:
          'This is the amount of [token_name] ([token_symbol]) that you paid as fees to the blockchain network to process your transaction. Sliver does not control or receive any part of this fee.',
        CONVENIENCE_FEE_FIELD_HELP_TITLE: 'Service Fee',
        CONVENIENCE_FEE_FIELD_HELP_DESCRIPTION:
          'This is the amount of [token_name] ([token_symbol]) that you paid as fees to Sliver for facilitating your transaction. This amounts to [convenience_fee_percent]% of the total transaction value.',
      },
    },
    COMPOSITION_CONFIGURATION_SCREEN: {
      HELP_TITLE: 'Personalize composition.',
      HELP_DESCRIPTION: `Changing the composition of assets impacts your tolerance for risk and the extent of potential returns. Higher returns typically come with higher risks, so it's important to choose a composition that aligns with your overall investment objectives.`,
    },
  },
  TRADE_ACTIONS: {
    LOADING_TITLE: 'Assets are being fetched.',
    LOADING_DESCRIPTION: `We're currently fetching all relevant assets. This will only take a moment.`,
    ERROR_LOADING_TITLE: `Temporary glitch showing assets.`,
    ERROR_LOADING_DESCRIPTION: `We’re experiencing a temporary glitch showing yield bearing assets. Try refreshing the page, or please check back again in a few minutes.`,
  },
};
export const LABELS = {
  WALLETS: {
    DEPOSIT: {
      TRANSFER_FROM_COINBASE_TITLE: `Coinbase`,
      TRANSFER_FROM_COINBASE_SUBTITLE: `Transfer from Coinbase.`,
      TRANSFER_FROM_EXTERNAL_WALLET_TITLE: `External Wallet`,
      TRANSFER_FROM_EXTERNAL_WALLET_SUBTITLE: `Transfer from an external wallet.`,
    },
  },
  PORTFOLIO_CARD: { CARD_HEADER_TITLE_WHEN_NO_ASSET_FOUND: 'Portfolio' },
  ALL_YIELD_BEARING_ASSETS_PAGE: { PAGE_HEADER: 'Strategies' },
  TRENDING_YIELD_BEARING_ASSETS_CARD: {
    CARD_HEADER: {
      TITLE: 'Trending Earn Strategies',
      SEE_ALL_BUTTON: 'See all',
    },
    CARD_BODY: {
      TABLE_COLUMN_HEADERS: {
        ASSET_NAME: 'Strategy',
        PERFORMANCE: 'Performance',
      },
    },
  },
  ALL_YIELD_BEARING_ASSETS_CARD: {
    CARD_HEADER: { TITLE: 'All Earn Strategies' },
    CARD_BODY: {
      TABLE_COLUMN_HEADERS: {
        ASSET_NAME: 'Strategy',
        MARKET_CAP: 'Market Cap.',
        PERFORMANCE: 'Return',
        RISK_PROFILE: 'Risk Profile',
        RETURN_PROFILE: 'Return Profile',
        USER_SCORE: 'User Score',
      },
    },
  },
  YIELD_BEARING_ASSET_DETAIL_CARD: {
    MARKET_CAPITALIZATION_CHART_TITLE: 'Market capitalization',
    MARKET_CAPITALIZATION_METRIC_LABEL: 'Market capitalization',
    MARKET_CAPITALIZATION_BLENDED_METRIC_LABEL: 'Blended Market capitalization',
    RETURN_CHART_TITLE: 'Return',
    RETURN_METRIC_LABEL: 'Current Yield',
    RETURN_BLENDED_METRIC_LABEL: 'Blended Return',
    ABOUT_SECTION_TITLE: 'About',
    KPI_SECTION_TITLE: 'Key statistics',
    SHARE_OF_COMPOSITION_METRIC_LABEL: 'Composition',
    NETWORK_LABEL: 'Network',
    HISTORICAL_YIELD_LABELS: {
      YTD: 'YTD Avg. Yield',
      D30: '30D Avg. Yield',
      D60: '60D Avg. Yield',
      D90: '90D Avg. Yield',
    },
  },
  YIELD_BEARING_ASSET_INVESTMENT_ACTIONS_CARD: {
    INVEST_SCREEN: {
      HEADER: 'Earn',
      DEPOSIT: {
        ASSET_SELECTION_FIELD_LABEl: 'Asset',
        AMOUNT_BOUGHT_FIELD_LABEL: 'Amount',
        BUY_BUTTON_LABEL: 'Earn',
      },
    },
    CONFIRMATION_REQUEST_SCREEN: {
      DEPOSIT: {
        SCREEN_HEADER: 'Confirm',
        ASSET_FIELD_LABEL: 'Asset',
        WALLET_FIELD_LABEL: 'Wallet',
        AMOUNT_FIELD_LABEL: 'Amount',
        NETWORK_FEE_LABEL: 'Network fee',
        CONVENIENCE_FEE_FIELD_LABEL: 'Service fee',
      },
      WITHDRAWAL: {
        SCREEN_HEADER: 'Confirm',
        ASSET_FIELD_LABEL: 'Asset',
        WALLET_FIELD_LABEL: 'Wallet',
        AMOUNT_FIELD_LABEL: 'Amount',
        NETWORK_FEE_LABEL: 'Network fee',
        CONVENIENCE_FEE_FIELD_LABEL: 'Service fee',
      },
    },
    CONFIRMATION_RECEIPT_SCREEN: {
      DEPOSIT: {
        SCREEN_HEADER: 'Processing',
        ASSET_FIELD_LABEL: 'Asset',
        WALLET_FIELD_LABEL: 'Wallet',
        AMOUNT_FIELD_LABEL: 'Amount',
        NETWORK_FEE_LABEL: 'Network fee',
        CONVENIENCE_FEE_FIELD_LABEL: 'Service fee',
      },
      WITHDRAWAL: {
        SCREEN_HEADER: 'Processing',
        ASSET_FIELD_LABEL: 'Asset',
        WALLET_FIELD_LABEL: 'Wallet',
        AMOUNT_FIELD_LABEL: 'Amount',
        NETWORK_FEE_LABEL: 'Network fee',
        CONVENIENCE_FEE_FIELD_LABEL: 'Service fee',
      },
    },
    ALLOCATION_CONFIGURATION_SCREEN: { SCREEN_HEADER: 'Personalize' },
  },
  TRADE_CARD: {
    TRADE_SCREEN: { HEADER: `Trade` },
    CONFIRMATION_REQUEST_SCREEN: { HEADER: `Confirm` },
    CONFIRMATION_RECEIPT_SCREEN: { HEADER: `Confirm` },
  },
};
export const WALLET = {
  DESCRIPTION_TITLE: `Wallets store digital assets.`,
  DESCRIPTION: `A wallet's address acts as its account number and is critical for transacting with it. Wallets are hosted on blockchain networks that faciliate and secure transactions using decentralized ledgers and cryptographic algorithms to ensure transparency, immutability, and trust.`,
  UNAUTHORIZED_USER_ERROR_TITLE: `You don't yet have access to Sliver.`,
  UNAUTHORIZED_USER_ERROR_DESCRIPTION: `Sliver is currently available to early and invited users only. If you'd like to be invited, please sign up for priority access at https://www.sliver.money/#get-priority-access, and we'll invite you as soon as we can.`,
  LOADING_TITLE: 'Your assets are being fetched.',
  LOADING_DESCRIPTION: `We’re currently fetching your assets. This will only take a moment.`,
  WALLET_NOT_FOUND_TITLE: 'Temporary glitch retrieving your wallet.',
  WALLET_NOT_FOUND_DESCRIPTION: `We’re experiencing a temporary glitch in safely retrieving your wallet. Rest assured, your wallet and all your assets in it are safely stored on the blockchain network. Try refreshing the page, or pease check back again in a few minutes.`,
  WALLET_FOUND_BUT_NO_ASSETS_FOUND_TITLE: 'No assets found.',
  WALLET_FOUND_BUT_NO_ASSETS_FOUND_DESCRIPTION: `You don't have any assets in your wallet just yet. If you are new to Sliver, please get started by depositing assets into your wallet.`,
  GENERIC_ERROR_LOADING_TITLE: 'Temporary glitch retrieving your assets.',
  GENERIC_ERROR_LOADING_DESCRIPTION:
    'We’re experiencing a temporary glitch in safely retrieving your assets. Rest assured, your wallet and all your assets in it are safely stored on the blockchain network. Try refreshing the page, or pease check back again in a few minutes.',
  DEPOSIT_ADDRESS_WARNING_TITLE: 'Double-check these details.',
  DEPOSIT_ADDRESS_WARNING_DESCRIPTION: `In the external wallet that you are depositing funds from, please make sure that you are specifying the correct wallet on Sliver as your destination. Double-check that the address and blockchain network are correct. Unfortunately, we have no control over external wallets to make your experience any better, so getting the asset, address, or network wrong might result in loss of funds.`,
  TRANSFER_FROM_COINBASE_PAY_HELP_TITLE: 'Transfer from Coinbase.',
  TRANSFER_FROM_COINBASE_PAY_HELP_DESCRIPTION:
    'Using Coinbase Onramp to bring your assets over takes just a few seconds and is the quickest way to put them to work for higher returns, better diversification, and at a fraction of the fees, especially the hidden ones such as spreads and margins that are generally not exposed up front in centralized services.',
  TRANSFER_FROM_EXTERNAL_WALLET_HELP_TITLE: `Transfer from an external wallet.`,
  TRANSFER_FROM_EXTERNAL_WALLET_HELP_DESCRIPTION: `Bring your assets over from any centralized custodial services such as Coinbase, Robinhood, Crypto.com, etc, or decentralized self-custodial wallets such as MetaMask, Zerion, Argent, etc, and put them to work in incredibly sophisticated decentralized investment products with ease that's decisively unmatched at a fraction of the fees, while keeping full custody of your assets.`,
  WITHDRAWAL_ADDRESS_WARNING_TITLE: 'Double-check these details.',
  WITHDRAWAL_ADDRESS_WARNING_DESCRIPTION: `Please double check that you are using an external wallet that can receive [asset_name] on the [blockchain_name] network. Unfortunately, we have no control over external wallets to make your experience any better, so getting the asset, address, or network wrong might result in loss of funds.`,
};
export const YIELD_BEARING_ASSET = {
  WALLET_FOUND_BUT_NO_ASSETS_FOUND_TITLE: 'No assets found.',
  WALLET_FOUND_BUT_NO_ASSETS_FOUND_DESCRIPTION: `You don't have any assets in your wallet to deploy. If you are new to Sliver, please get started by depositing assets into your wallet.`,
  PROCESSING: {
    DEPOSIT_FEE_ESTIMATION_TAKING_LONGER_TITLE:
      'Estimating fees is taking longer than usual.',
    DEPOSIT_FEE_ESTIMATION_TAKING_LONGER_DESCRIPTION: `Sliver doesn't have control over this timing as it depends on how busy the blockchain network is at the moment. Rest assured, your wallets and assets are safe on the blockchain.`,
    DEPOSIT_IN_PROGRESS_TAKING_LONGER_TITLE:
      'Deployment is taking longer than usual.',
    DEPOSIT_IN_PROGRESS_TAKING_LONGER_DESCRIPTION: `Sliver doesn't have control over this timing as it depends on how busy the blockchain network is at the moment. Rest assured, your wallets and assets are safe on the blockchain.`,
  },
  CHARTS: {
    HISTORICAL_PERFORMANCE: {
      LOADING_TITLE: 'Fetching historical performance.',
      LOADING_DESCRIPTION: `We're currently fetching [yield_bearing_asset_ticker]'s historical performance. This will only take a moment.`,
      MARKET_CAPITALIZATION_TITLE: 'Historical Performance',
      MARKET_CAPITALIZATION_CHIP_LABEL: 'Market capitalization',
      RETURN_TITLE: 'Historical Performance',
      RETURN_CHIP_LABEL: 'Return',
    },
  },
};
export const TRADE = {
  WALLET_FOUND_BUT_NO_ASSETS_FOUND_TITLE: 'No assets found.',
  WALLET_FOUND_BUT_NO_ASSETS_FOUND_DESCRIPTION: `You don't have any assets in your wallet to sell. If you are new to Sliver, please get started by depositing assets into your wallet.`,
  BROWSE_TRADABLE_TOKENS_LABEL: `Browse Assets`,
  PROCESSING: {
    TRADE_FEE_ESTIMATION_TAKING_LONGER_TITLE:
      'Estimating fees is taking longer than usual.',
    TRADE_FEE_ESTIMATION_TAKING_LONGER_DESCRIPTION: `Sliver doesn't have control over this timing as it depends on how busy the blockchain network is at the moment. Rest assured, your wallets and assets are safe on the blockchain.`,
    TRADE_IN_PROGRESS_TAKING_LONGER_TITLE: 'Trade is taking longer than usual.',
    TRADE_IN_PROGRESS_TAKING_LONGER_DESCRIPTION: `Sliver doesn't have control over this timing as it depends on how busy the blockchain network is at the moment. Rest assured, your wallets and assets are safe on the blockchain.`,
  },
};
export const TRANSACTIONS = {
  CARD_HEADER_WHEN_SHOWING_YIELD_BEARING_ASSET_SPECIFIC_TRANSACTIONS: `Related Transactions`,
  CARD_HEADER_WHEN_SHOWING_TRADE_SPECIFIC_TRANSACTIONS: `Related Transactions`,
  PROCESSING_TITLE: 'Transaction is being processed.',
  PROCESSING_DESCRIPTION:
    'Your transaction has been submitted to the blockchain network. It might take a few seconds to minutes to complete. Check back on its status in a bit as the network completes processing your transaction.',
  LOADING_TITLE: 'Your transactions are being fetched.',
  LOADING_DESCRIPTION: `We’re currently fetching your transactions. This will only take a moment.`,
  TRANSACTIONS_NOT_FOUND_TITLE: 'No transactions found.',
  TRANSACTIONS_NOT_FOUND_DESCRIPTION: `There are currently no transactions to show. If you are new to Sliver, please get started by depositing assets into your wallet.`,
  FILTERED_TRANSACTIONS_NOT_FOUND_TITLE: 'No related transactions found.',
  FILTERED_TRANSACTIONS_NOT_FOUND_DESCRIPTION: `There are currently no related transactions to show. If you are new to Sliver, please get started by depositing assets into your wallet.`,
  UNAUTHORIZED_USER_ERROR_TITLE: `You don't yet have access to Sliver.`,
  UNAUTHORIZED_USER_ERROR_DESCRIPTION: `Sliver is currently available to early and invited users only. If you'd like to be invited, please sign up for priority access at https://www.sliver.money/#get-priority-access, and we'll invite you as soon as we can.`,
  GENERIC_ERROR_LOADING_TITLE: 'Temporary glitch retrieving your transactions.',
  GENERIC_ERROR_LOADING_DESCRIPTION:
    'We’re experiencing a temporary glitch in retrieving your transactions. Rest assured, your wallet and all your assets in it are safely stored on the blockchain network. Try refreshing the page, or pease check back again in a few minutes.',
};
export const ALL_YIELD_BEARING_ASSETS_CARD = { HEADER: `Earn` };
export const YIELD_BEARING_ASSET_ACTIONS_CARD = {
  LOADING_TITLE: 'Assets are being fetched.',
  LOADING_DESCRIPTION: `We're currently fetching all relevant assets. This will only take a moment.`,
  SUPPORTED_TOKENS_INFORMATION_TITLE: `Assets that you can deploy.`,
  SUPPORTED_TOKENS_INFORMATION_DESCRIPTION: `You can use most assets on [supported_networks] to deploy into the [yield_bearing_asset_ticker] strategy.`,
  SUPPORTED_TOKENS_NOT_IN_WALLET_WARNING_TITLE: `No asset available to deploy.`,
  SUPPORTED_TOKENS_NOT_IN_WALLET_WARNING_DESCRIPTION: `You currently don't have assets in your wallet that can be deployed into the [yield_bearing_asset_ticker] strategy. Simply deposit a supported asset into your wallet to get started. You can use most assets on [supported_networks] to deploy into the [yield_bearing_asset_ticker] strategy.`,
  SCREENS: {
    DEPOSIT_FORM: {
      HEADER_LABEL: `Earn`,
      ASSET_SECTION_LABEL: `Deploy`,
      ASSET_SELECTION_FIELD: {
        LABEL: `Asset`,
        HELP_TITLE: `Asset to deploy.`,
        HELP_DESCRIPTION: `You will use this asset to deploy into the [yield_bearing_asset_ticker] strategy.`,
      },
      AMOUNT_FIELD: {
        LABEL: `Amount`,
        HELP_TITLE: `Amount to deploy.`,
        HELP_DESCRIPTION: `This is the amount of the selected asset that you will deploy into the [yield_bearing_asset_ticker] strategy.`,
      },
      PROJECTION_CHART: {
        NO_ASSET_OR_AMOUNT_IS_PRESENT_TITLE: `Select an asset and enter an amount.`,
        NO_ASSET_OR_AMOUNT_IS_PRESENT_DESCRIPTION: `Select an asset and enter an amount to see a projection of the potential returns of the [yield_bearing_asset_ticker] strategy.`,
      },
      EARN_BUTTON_LABEL: `Review`,
      ERROR_MESSAGES: {
        ASSET_SELECTION_FIELD_EMPTY_ERROR_MESSAGE: `Pick an asset to deploy.`,
        AMOUNT_FIELD_INVALID_ERROR_MESSAGE: `Enter a valid amount to deploy.`,
        AMOUNT_FIELD_LESS_THAN_AVAILABLE_ERROR_MESSAGE: `You have [available_funds_in_token_currency] to deploy.`,
        AMOUNT_FIELD_ZERO_ERROR_MESSAGE: `Enter an amount greater than 0 to deploy.`,
      },
    },
    DEPOSIT_CONFIRMATION_REQUEST: {
      HEADER_LABEL: `Confirm`,
      CANCEL_BUTTON_LABEL: `Cancel`,
      CONFIRM_BUTTON_LABEL: `Confirm`,
      DETAILS: {
        BOUGHT_ASSET: {
          LABEL: `Buy`,
          TOOLTIP_TITLE: `Asset to buy.`,
          TOOLTIP_DESCRIPTION: `You will buy this asset in the specified composition as a result of deploying into the [yield_bearing_asset_ticker] strategy.`,
        },
        SOLD_ASSET: {
          LABEL: `Sell`,
          TOOLTIP_TITLE: `Asset to sell.`,
          TOOLTIP_DESCRIPTION: `This is the asset that you will sell to deploy into the [yield_bearing_asset_ticker] strategy.`,
        },
        AMOUNT: {
          LABEL: `Amount`,
          TOOLTIP_TITLE: `Amount to deploy.`,
          TOOLTIP_DESCRIPTION: `This is the amount that you will deploy into the [yield_bearing_asset_ticker] strategy.`,
        },
        NETWORK_FEE: {
          LABEL: `Network Fee`,
          TOOLTIP_TITLE: `Network fee to pay.`,
          TOOLTIP_DESCRIPTION: `This is the amount that you will pay in fees to the blockchain network to facilitate this transaction. Depending on the time of the day and how busy the network is, this fee can fluctuate quite a bit. Sliver doesn't dictate or acquire any part of this fee.`,
        },
        CONVENIENCE_FEE: {
          LABEL: `Service Fee`,
          TOOLTIP_TITLE: `Service fee to pay.`,
          TOOLTIP_DESCRIPTION: `This is the amount that you will pay in fees to Sliver to facilitate this transaction. This amounts to [convenience_fee_percent]% of the overall transaction value.`,
          CHIP_LABEL_FOR_FREE: `Free`,
        },
      },
      ERROR_MESSAGES: {
        FEE_ESTIMATE_FETCH_ASSET_NOT_SUPPORTED_ERROR_TITLE: `Asset not supported to deploy.`,
        FEE_ESTIMATE_FETCH_ASSET_NOT_SUPPORTED_ERROR_DESCRIPTION: `[sell_asset_name] ([sell_asset_symbol], [sell_asset_network]) does not support deployment into the [yield_bearing_asset_ticker] strategy. Please try a different asset (preferably on the same network) to deploy.`,
        FEE_ESTIMATE_FETCH_INSUFFICIENT_BALANCE_ERROR_TITLE: `Not enough balance to proceed.`,
        FEE_ESTIMATE_FETCH_INSUFFICIENT_BALANCE_ERROR_DESCRIPTION: `You don't have enough [sell_asset_name] ([sell_asset_symbol], [sell_asset_network]) in your wallet to deploy into the [yield_bearing_asset_ticker] strategy. Please deposit more [sell_asset_name] ([sell_asset_symbol], [sell_asset_network]) into your wallet or select a different asset (preferably on the same network) to proceed.`,
        FEE_ESTIMATE_FETCH_INSUFFICIENT_AMOUNT_ERROR_TITLE: `Amount to deploy is too low.`,
        FEE_ESTIMATE_FETCH_INSUFFICIENT_AMOUNT_ERROR_DESCRIPTION: `The amount that you are attempting to deploy into the [yield_bearing_asset_ticker] strategy is too low. Please increase your amount to proceed.`,
        FEE_ESTIMATE_FETCH_GENERIC_ERROR_TITLE: `Temporary glitch with deployment.`,
        FEE_ESTIMATE_FETCH_GENERIC_ERROR_DESCRIPTION: `We're currently experiencing a temporary glitch with deploying into the [yield_bearing_asset_ticker] strategy. Please try again in a few minutes.`,
        FEE_ESTIMATE_FETCH_ASSET_NOT_SUPPORTED_ERROR_NETWORK_FEE_PLACEHOLDER: `Not available`,
        FEE_ESTIMATE_FETCH_ASSET_NOT_SUPPORTED_ERROR_CONVENIENCE_FEE_PLACEHOLDER: `Not available`,
        FEE_ESTIMATE_FETCH_INSUFFICIENT_BALANCE_ERROR_NETWORK_FEE_PLACEHOLDER: `Not available`,
        FEE_ESTIMATE_FETCH_INSUFFICIENT_BALANCE_ERROR_CONVENIENCE_FEE_PLACEHOLDER: `Not available`,
        FEE_ESTIMATE_FETCH_INSUFFICIENT_AMOUNT_ERROR_NETWORK_FEE_PLACEHOLDER: `Not available`,
        FEE_ESTIMATE_FETCH_INSUFFICIENT_AMOUNT_ERROR_CONVENIENCE_FEE_PLACEHOLDER: `Not available`,
      },
    },
    DEPOSIT_CONFIRMATION_RECEIPT: {
      HEADER_LABEL: `Processing`,
      DONE_BUTTON_LABEL: `Done`,
      DETAILS: {
        BOUGHT_ASSET: {
          LABEL: `Bought`,
          TOOLTIP_TITLE: `Asset bought.`,
          TOOLTIP_DESCRIPTION: `You bought this asset in the specified composition as a result of deploying into the [yield_bearing_asset_ticker] strategy.`,
        },
        SOLD_ASSET: {
          LABEL: `Sold`,
          TOOLTIP_TITLE: `Asset sold.`,
          TOOLTIP_DESCRIPTION: `This is the asset that you sold to deploy into the [yield_bearing_asset_ticker] strategy.`,
        },
        AMOUNT: {
          LABEL: `Amount`,
          TOOLTIP_TITLE: `Amount deployed.`,
          TOOLTIP_DESCRIPTION: `This is the amount that you deployed into the [yield_bearing_asset_ticker] strategy.`,
        },
        NETWORK_FEE: {
          LABEL: `Network Fee`,
          TOOLTIP_TITLE: `Network fee paid.`,
          TOOLTIP_DESCRIPTION: `This is the amount that you paid in fees to the blockchain network to facilitate this transaction. Sliver didn't dictate or acquire any part of this fee.`,
        },
        CONVENIENCE_FEE: {
          LABEL: `Service Fee`,
          TOOLTIP_TITLE: `Service fee paid.`,
          TOOLTIP_DESCRIPTION: `This is the amount that you paid in fees to Sliver to facilitate this transaction. This amounts to [convenience_fee_percent]% of the overall transaction value.`,
          CHIP_LABEL_FOR_FREE: `Free`,
        },
      },
    },
    COMPOSITION: {
      HEADER: {
        WHEN_COMPOSITION_IS_EDITABLE: 'Change Composition',
        WHEN_COMPOSITION_IS_NOT_EDITABLE: 'Composition',
      },
      SUBHEADER: {
        WHEN_COMPOSITION_IS_EDITABLE: 'Personalize composition.',
        WHEN_COMPOSITION_IS_NOT_EDITABLE:
          'You chose to personalize the composition.',
      },
      DEFAULT_RETURN_LABEL: `Default Return`,
      PERSONALIZED_RETURN_LABEL: `Personalized Return`,
    },
  },
};
export const TRADE_PAGE = {
  TRADE_PAGE_WITH_TOKEN_TICKER: {
    TOKEN_NOT_FOUND_ERROR_TITLE: `Asset not found.`,
    TOKEN_NOT_FOUND_ERROR_DESCRIPTION: `We currently don't support trading [asset_ticker]. Please choose a different asset to trade.`,
    GENERIC_ERROR_TITLE: `Temporary glitch fetching assets to trade.`,
    GENERIC_ERROR_DESCRIPTION:
      'We’re experiencing a temporary glitch fetching assets to trade. Try refreshing the page, or pease check back again in a few minutes.',
  },
};
export const TRADE_CARD = {
  SCREENS: {
    TRADE: {
      LABELS: {
        HEADER: `Trade`,
        TRADE_BUTTON: `Review`,
        SELL_ASSET_SECTION_LABEL: `Sell`,
        BUY_ASSET_SECTION_LABEL: `Buy`,
        SELL_ASSET_SELECTION_FIELD: {
          LABEL: `Asset`,
          TOOLTIP_TITLE: `Asset to sell.`,
          TOOLTIP_DESCRIPTION: `This is the asset in your wallet that you will sell in this trade.`,
        },
        AMOUNT_TRADED_FIELD: {
          LABEL: `Amount`,
          TOOLTIP_TITLE: `Amount to trade.`,
          TOOLTIP_DESCRIPTION: `This is the amount that you will trade.`,
        },
        BUY_ASSET_SELECTION_FIELD: {
          LABEL: `Asset`,
          TOOLTIP_TITLE: `Asset to buy.`,
          TOOLTIP_DESCRIPTION: `This is the asset that you will buy in this trade.`,
        },
      },
      MESSAGES: {
        VALIDATION: {
          SELL_ASSET_SELECTION_FIELD_EMPTY_ERROR_MESSAGE:
            'Pick an asset to sell.',
          AMOUNT_TRADED_FIELD_INVALID_ERROR_MESSAGE: `Enter a valid amount to trade.`,
          AMOUNT_TRADED_FIELD_LESS_THAN_AVAILABLE_ERROR_MESSAGE: `You have [available_funds_in_token_currency] to trade.`,
          AMOUNT_TRADED_FIELD_ZERO_ERROR_MESSAGE: `Enter an amount greater than 0 to trade.`,
          SELL_ASSET_REQUIRED: `Please select an asset to sell.`,
          BUY_ASSET_REQUIRED: `Please select an asset to buy.`,
          INVALID_AMOUNT: `Enter a valid amount.`,
        },
        LOADING: {
          WALLETS_AND_TRADEABLE_TOKENS_LOADING: {
            TITLE: 'Your assets are being fetched.',
            DESCRIPTION:
              'We’re currently fetching your assets. This will only take a moment.',
          },
          WALLETS_LOADING: {
            TITLE: 'Your assets are being fetched.',
            DESCRIPTION:
              'We’re currently fetching your assets. This will only take a moment.',
          },
          TRADEABLE_TOKENS_LOADING: {
            TITLE: 'Your assets are being fetched.',
            DESCRIPTION:
              'We’re currently fetching your assets. This will only take a moment.',
          },
        },
        ERROR: {
          WALLETS_AND_TRADEABLE_TOKENS_LOADING_ERROR: {
            TITLE: 'Temporary glitch showing your assets.',
            DESCRIPTION:
              'We’re experiencing a temporary glitch showing your assets. Rest assured, your wallet and all your assets in it are safely stored on the network. Try refreshing the page, or pease check back again in a few minutes.',
          },
          WALLETS_LOADING_ERROR: {
            TITLE: 'Temporary glitch showing your assets.',
            DESCRIPTION:
              'We’re experiencing a temporary glitch showing your assets. Rest assured, your wallet and all your assets in it are safely stored on the network. Try refreshing the page, or pease check back again in a few minutes.',
          },
          TRADEABLE_TOKENS_LOADING_ERROR: {
            TITLE: 'Temporary glitch with buying assets.',
            DESCRIPTION:
              'We’re experiencing a temporary glitch with buying assets. Try refreshing the page, or pease check back again in a few minutes.',
          },
        },
      },
    },
    TRADE_CONFIRMATION_REQUEST: {
      LABELS: {
        HEADER: `Confirm`,
        CANCEL_BUTTON: `Cancel`,
        CONFIRM_BUTTON: `Confirm`,
        CONFIRMATION_DETAILS: {
          SELL_ASSET: `Sell`,
          BUY_ASSET: `Buy`,
          WALLET: `Wallet`,
          AMOUNT: `Amount`,
          GAS_FEE: `Network Fee`,
          CONVENIENCE_FEE: `Service Fee`,
        },
      },
      MESSAGES: {
        CHIP_LABEL_FOR_FREE: `Free`,
        TOOLTIPS: {
          BUY_ASSET_TITLE: `Asset to buy.`,
          BUY_ASSET_DESCRIPTION: `You will buy [buy_asset_name] ([buy_asset_symbol]) using [sell_asset_name] ([sell_asset_symbol]) in your wallet.`,
          SELL_ASSET_TITLE: `Asset to sell.`,
          SELL_ASSET_DESCRIPTION: `You will sell [sell_asset_name] ([sell_asset_symbol]) in your wallet to buy [buy_asset_name] ([buy_asset_symbol]).`,
          AMOUNT_TITLE: `Amount to sell.`,
          AMOUNT_DESCRIPTION: `This is the amount of [sell_asset_name] ([sell_asset_symbol]) that you will use to buy [buy_asset_name] ([buy_asset_symbol]) with.`,
          WALLET_TITLE: `Spending wallet.`,
          WALLET_DESCRIPTION: `This is the wallet that has the [sell_asset_name] ([sell_asset_symbol]) that you will use to buy [buy_asset_name] ([buy_asset_symbol]) with.`,
          NETWORK_FEE_TITLE: `Network fee to pay.`,
          NETWORK_FEE_DESCRIPTION: `This is the amount of [sell_asset_name] ([sell_asset_symbol]) that you will pay in fees to the blockchain network to facilitate this transaction. Depending on the time of the day and how busy the network is, this fee can fluctuate quite a bit. Sliver doesn't dictate or acquire any part of this fee.`,
          CONVENIENCE_FEE_TITLE: `Service fee to pay.`,
          CONVENIENCE_FEE_DESCRIPTION: `This is the amount of [sell_asset_name] ([sell_asset_symbol]) that you will pay in fees to Sliver to facilitate this transaction. This amounts to [convenience_fee_percent]% of the overall transaction value.`,
        },
        ERRORS: {
          FEE_ESTIMATE_FETCH_ASSET_NOT_SUPPORTED_ERROR_TITLE: `Trading is not supported for these assets.`,
          FEE_ESTIMATE_FETCH_ASSET_NOT_SUPPORTED_ERROR_DESCRIPTION: `[sell_asset_name] ([sell_asset_symbol], [sell_asset_network]) does not support trading with [buy_asset_name] ([buy_asset_symbol], [buy_asset_network]) at this time. Please try a different asset (preferably on the same network) to trade with.`,
          FEE_ESTIMATE_FETCH_INSUFFICIENT_BALANCE_ERROR_TITLE: `Not enough balance to proceed.`,
          FEE_ESTIMATE_FETCH_INSUFFICIENT_BALANCE_ERROR_DESCRIPTION: `You don't have enough [sell_asset_name] ([sell_asset_symbol], [sell_asset_network]) in your wallet to proceed with this trade. Please try a different asset (preferably on the same network) or reduce the amount to trade with.`,
          FEE_ESTIMATE_FETCH_INSUFFICIENT_AMOUNT_ERROR_TITLE: `Amount to trade is too low.`,
          FEE_ESTIMATE_FETCH_INSUFFICIENT_AMOUNT_ERROR_DESCRIPTION: `The amount you are attempting to trade is less than the blockchain network fees required to process this transaction. Please increase your amount to cover the required fees.`,
          FEE_ESTIMATE_FETCH_GENERIC_ERROR_TITLE: `Temporary glitch with trading.`,
          FEE_ESTIMATE_FETCH_GENERIC_ERROR_DESCRIPTION: `We're currently experiencing a temporary glitch with trading. Please try again in a few minutes.`,
          FEE_ESTIMATE_FETCH_ASSET_NOT_SUPPORTED_ERROR_NETWORK_FEE_PLACEHOLDER: `Not available`,
          FEE_ESTIMATE_FETCH_ASSET_NOT_SUPPORTED_ERROR_CONVENIENCE_FEE_PLACEHOLDER: `Not available`,
          FEE_ESTIMATE_FETCH_INSUFFICIENT_BALANCE_ERROR_NETWORK_FEE_PLACEHOLDER: `Not available`,
          FEE_ESTIMATE_FETCH_INSUFFICIENT_BALANCE_ERROR_CONVENIENCE_FEE_PLACEHOLDER: `Not available`,
          FEE_ESTIMATE_FETCH_INSUFFICIENT_AMOUNT_ERROR_NETWORK_FEE_PLACEHOLDER: `Not available`,
          FEE_ESTIMATE_FETCH_INSUFFICIENT_AMOUNT_ERROR_CONVENIENCE_FEE_PLACEHOLDER: `Not available`,
        },
      },
    },
    TRADE_CONFIRMATION_RECEIPT: {
      LABELS: {
        HEADER: `Processing`,
        DONE_BUTTON: `Done`,
        RECEIPT_DETAILS: {
          SELL_ASSET: `Sell`,
          BUY_ASSET: `Buy`,
          WALLET: `Wallet`,
          AMOUNT: `Amount`,
          GAS_FEE: `Network Fee`,
          CONVENIENCE_FEE: `Service Fee`,
        },
      },
      MESSAGES: {
        CHIP_LABEL_FOR_FREE: `Free`,
        TOOLTIPS: {
          BUY_ASSET_TITLE: `Asset to buy.`,
          BUY_ASSET_DESCRIPTION: `You bought [buy_asset_name] ([buy_asset_symbol]) using [sell_asset_name] ([sell_asset_symbol]) in your wallet.`,
          SELL_ASSET_TITLE: `Asset to sell.`,
          SELL_ASSET_DESCRIPTION: `You sold [sell_asset_name] ([sell_asset_symbol]) in your wallet to buy [buy_asset_name] ([buy_asset_symbol]).`,
          AMOUNT_TITLE: `Amount to sell.`,
          AMOUNT_DESCRIPTION: `This is the amount of [sell_asset_name] ([sell_asset_symbol]) that you bought [buy_asset_name] ([buy_asset_symbol]) with.`,
          WALLET_TITLE: `Spending wallet.`,
          WALLET_DESCRIPTION: `This is the wallet that had the [sell_asset_name] ([sell_asset_symbol]) that you used to buy [buy_asset_name] ([buy_asset_symbol]) with.`,
          NETWORK_FEE_TITLE: `Network fee to pay.`,
          NETWORK_FEE_DESCRIPTION: `This is the amount of [sell_asset_name] ([sell_asset_symbol]) that you paid in fees to the blockchain network to facilitate this transaction. Sliver doesn't dictate or acquire any part of this fee.`,
          CONVENIENCE_FEE_TITLE: `Service fee to pay.`,
          CONVENIENCE_FEE_DESCRIPTION: `This is the amount of [sell_asset_name] ([sell_asset_symbol]) that you paid in fees to Sliver to facilitate this transaction. This amounts to [convenience_fee_percent]% of the overall transaction value.`,
        },
        TRANSACTION_PROCESSING_TITLE: `Transaction is being processed.`,
        TRANSACTION_PROCESSING_DESCRIPTION: `Your transaction has been submitted to the blockchain network. It might take a few seconds to minutes to complete. Check back on its status in a bit as the network completes processing your transaction.`,
      },
    },
  },
};
export const YIELD_BEARING_ASSET_UNDERLYING_TOKENS_DETAILS_CAROUSEL_SECTION = {
  MAIN_TITLE: `Asset Breakdown`,
  MAIN_DESCRIPTION: `These are the underlying assets that form the building blocks of [list_of_underlying_yield_bearing_asset_name]. These assets grow to earn you interest, offering you a clear picture of how each asset contributes to the return on your investment.`,
};
export const YIELD_BEARING_ASSET_ADVANCED_DETAILS_TRAY = {
  UNDERLYING_TOKENS_DETAILS_BUTTON_TITLE: `Details`,
};
export const UNDERLYING_YIELD_BEARING_ASSET_DETAIL_SECTION = {
  CHART_LOADING_TITLE: 'Historical data being fetched.',
  CHART_LOADING_DESCRIPTION: `We're currently fetching historical data for this asset. This will only take a moment.`,
  MARKET_CAPITALIZATION_CHART_TITLE: 'Market capitalization',
  RETURN_CHART_TITLE: 'Return',
};
export const RATINGS = {
  SECTION_TITLE: 'Help us improve your experience!',
  SECTION_DESCRIPTION:
    'Your feedback is optional, but it helps us enhance our services and assist others in making informed decisions. Thank you for contributing to our community!',
  STRATEGY_QUALITY_RATING_TITLE: 'Quality of strategy',
  EXPERIENCE_QUALITY_RATING_TITLE: 'Quality of experience',
};
export const FEEDBACK = {
  SECTION_TITLE: 'Help us improve your experience!',
  SECTION_DESCRIPTION:
    'Your feedback is optional, but it helps us enhance our services and assist others in making informed decisions. Thank you for contributing to our community!',
  FORM: {
    PLACEHOLDER:
      'What worked well?\u000AWhat could be improved?\u000AWhat is missing?',
    SUBMIT_BUTTON: 'Submit',
    ERROR_ALERT_TITLE: 'Something went wrong.',
    SUCCESS_ALERT_TITLE: 'Thank you for your feedback!',
    NOT_LOGGED_IN_ERROR: 'You must be logged in to submit feedback.',
    GENERIC_ERROR:
      'Something went wrong while submitting your feedback. Please try again in a few minutes.',
    SUCCESS_MESSAGE:
      "We've received your feedback, and we'll incorporate it into our roadmap as soon as possible.",
  },
};
export const ROADMAP = {
  TRAY_TITLE: `Roadmap`,
  TRAY_DESCRIPTION: `Explore our upcoming features and enhancements designed to make investing in digital assets with Sliver even more accessible and rewarding.`,
};
const ERROR_TITLE = 'Our servers are currently experiencing issues.';
const ERROR_DESCRIPTION = `We're experiencing some technical difficulties with our servers. Rest assured, your wallet and all your assets are safely stored on the blockchain network. Please try again in a few minutes.`;
export const API_ERRORS = {
  SERVER_ERROR_TITLE: ERROR_TITLE,
  SERVER_ERROR_DESCRIPTION: ERROR_DESCRIPTION,
  NETWORK_ERROR_TITLE: ERROR_TITLE,
  NETWORK_ERROR_DESCRIPTION: ERROR_DESCRIPTION,
  TIMEOUT_ERROR_TITLE: ERROR_TITLE,
  TIMEOUT_ERROR_DESCRIPTION: ERROR_DESCRIPTION,
  FORBIDDEN_ERROR_TITLE: ERROR_TITLE,
  FORBIDDEN_ERROR_DESCRIPTION: ERROR_DESCRIPTION,
  NOT_FOUND_ERROR_TITLE: ERROR_TITLE,
  NOT_FOUND_ERROR_DESCRIPTION: ERROR_DESCRIPTION,
  RATE_LIMIT_ERROR_TITLE: ERROR_TITLE,
  RATE_LIMIT_ERROR_DESCRIPTION: ERROR_DESCRIPTION,
  CORS_ERROR_TITLE: ERROR_TITLE,
  CORS_ERROR_DESCRIPTION: ERROR_DESCRIPTION,
  PARSE_ERROR_TITLE: ERROR_TITLE,
  PARSE_ERROR_DESCRIPTION: ERROR_DESCRIPTION,
  AUTH_ERROR_TITLE: ERROR_TITLE,
  AUTH_ERROR_DESCRIPTION: ERROR_DESCRIPTION,
  SESSION_EXPIRED_ERROR_TITLE: ERROR_TITLE,
  SESSION_EXPIRED_ERROR_DESCRIPTION: ERROR_DESCRIPTION,
};
export const REWARDS = {
  LABEL: `Interest`,
  HEADER: `Earn`,
  SUB_HEADER: `Summary`,
  DEPLOYED_ASSETS_LABEL: `Assets Deployed`,
  EFFECTIVE_RETURN_LABEL: `Current Return`,
  REWARDS_EARNED_LABEL: `Interest Earned`,
  EFFECTIVE_MARKET_CAPITALIZATION_LABEL: `Market Capitalization`,
};
export const REFERRAL = {
  SECTION_TITLE: `Referral`,
  TITLE: `Refer to earn rewards.`,
  DESCRIPTION: `If you are finding Sliver helpful, consider inviting your friends with your referral code to grow your rewards and secure proportional allocations in our upcoming utility token.`,
  LOADING_TITLE: `Referral details are being fetched.`,
  LOADING_DESCRIPTION: `We are currently fetching your referral details. This will only take a moment.`,
  ERROR_TITLE: `Temporary glitch with referral details.`,
  ERROR_DESCRIPTION: `We're experiencing a temporary glitch with your referral details. Try refreshing the page, or please check back again in a few minutes.`,
  GENERATE_ERROR_TITLE: `Temporary glitch generating your referral code.`,
  GENERATE_ERROR_DESCRIPTION: `We're experiencing a temporary glitch generating your referral code. Please try again in a few moments.`,
  APPLY_ERROR_TITLE: `Unable to apply referral code.`,
  APPLY_ERROR_DESCRIPTION: `We couldn't apply this referral code. It may be invalid or you may have already used a referral code.`,
  APPLY_NETWORK_ERROR_TITLE: `Connection issue while applying referral code.`,
  APPLY_NETWORK_ERROR_DESCRIPTION: `We're having trouble connecting to our servers. Please check your internet connection and try again.`,
  APPLY_SERVER_ERROR_TITLE: `Temporary server issue.`,
  APPLY_SERVER_ERROR_DESCRIPTION: `We're experiencing a temporary issue with our servers. Please try again in a few moments.`,
  APPLY_ALREADY_USED_ERROR_TITLE: `You've already used a referral code.`,
  APPLY_ALREADY_USED_ERROR_DESCRIPTION: `You've already applied a referral code to your account. Each account can only use one referral code.`,
  APPLY_SUCCESS_TITLE: `Thank you for applying a referral code!`,
  APPLY_SUCCESS_DESCRIPTION: `Your account has been updated. You and your friend will both benefit from increased rewards and allocations in our upcoming utility token.`,
  ALREADY_USED_TITLE: `Thank you for using a referral code!`,
  ALREADY_USED_DESCRIPTION: `You were referred by [referral_code].`,
  WERE_YOU_REFERRED_TITLE: `Were you referred?`,
  WERE_YOU_REFERRED_DESCRIPTION: `If a friend referred you and you have their referral code, be sure to apply it here – it'll help both you and your friend grow your rewards and secure proportional allocations in our upcoming utility token.`,
  REFERRAL_CODE_LABEL: `Enter your friend's referral code`,
  REFERRAL_CODE_REQUIRED: `Referral code is required`,
  APPLY_BUTTON_TEXT: `Apply`,
  GENERATE_BUTTON_TEXT: `Generate referral code`,
  TRY_AGAIN_BUTTON_TEXT: `Try Again`,
  BETA_RESTRICTION_TITLE: `This feature requires beta access.`,
  BETA_RESTRICTION_DESCRIPTION: `The referral program is currently available only to beta users. Stay tuned for updates as we roll out this feature to all users.`,
  EMAIL_SUBJECT: `Join me on Sliver!`,
  EMAIL_BODY: `Hey!\n\nI'm using Sliver and thought you might like it too.\n\nUse my referral code after you sign up: [referral_code].\n\nWe'll both get extra rewards in token allocations and discounted fees!\n\nSign up at https://app.sliver.money/ \n\nEnjoy!`,
  INVITE_BUTTON_TEXT: `Invite a Friend & Earn Rewards`,
};
export const PORTFOLIO = {
  LABEL: `Portfolio`,
  HEADER: `Assets`,
  SUB_HEADER: `Summary`,
};
export const ERROR_BOUNDARY = {
  ILLUSTRATION_URL: '/images/svg/peace.svg',
  TITLE: 'You caught our nodes meditating.',
  DECRIPTION: `Even the blockchain needs a moment of zen. Let’s give it another go and try to get you right back on chain, or check back in a few minutes, and we'll have this sorted out.`,
};
export const SMALL_SCREEN_BOUNDARY = {
  TITLE: 'We forgot to shrink ourselves.',
  DECRIPTION: `Looks like Sliver hasn't mastered the art of minimalism just yet. For the best experience, try resizing your window or switching to a slightly larger device. If you have have an account with Sliver, rest assured, your wallet and all your assets in it are safely stored on the blockchain network. `,
};
export const NEWS = {
  LOADING_TITLE: 'Latest news is being fetched.',
  LOADING_DESCRIPTION:
    'We’re currently fetching the latest news. This will only take a moment.',
  ERROR_LOADING_TITLE: 'Temporary glitch showing news.',
  ERROR_LOADING_DESCRIPTION:
    'We’re experiencing a temporary glitch showing news. Try refreshing the page, or please check back again in a few minutes.',
  EMPTY_NEWS_TITLE: 'No news found.',
  EMPTY_NEWS_DESCRIPTION:
    'There are currently no news articles to show. Try refreshing the page, or please check back again in a few minutes.',
};
